import React, {useState} from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import {formatedDateString} from '../../../utils/managerInsightUtils';
import AssignedTrainingCard from '../AssignedTrainingCard';
import SearchContainer from '../SearchContainer';
import Tabs from '../Tabs';
import TeamPerformanceCard from '../TeamPerformanceCard';

import styles from './styles.module.scss';

function GlobalSearch({
  users,
  totalUserCount,
  contents,
  keyword,
  goToManagerInsightsContentDetail,
  goToManagerInsightsUserDetail,
  insightId,
  managerId,
}) {
  const [contentCount, setContentCount] = useState(0);
  const [userCount, setUserCount] = useState(0);

  return (
    <Tabs
      items={[
        {
          id: '1',
          title: 'Trainings',
          count: contentCount,
          content: (
            <SearchContainer
              type='content'
              keyword={keyword}
              data={contents}
              onCountChange={setContentCount}
              searchField='title'
              rowRender={(content) => {
                const completedUserCount = Object.keys(
                  content.completedUsers
                ).length;
                const nonCompletedUsersCount =
                  totalUserCount - completedUserCount;

                return (
                  <AssignedTrainingCard
                    key={content.id}
                    imageUrl={content.image}
                    icon={content.icon}
                    title={content.title}
                    publishedDate={
                      content.publishedAt &&
                      formatedDateString(content.publishedAt)
                    }
                    completionInformation={`${completedUserCount} of ${totalUserCount}`}
                    users={content.notCompletedUsers}
                    noneCompletionInformation={`${content.notCompletedUsers.join(
                      ', '
                    )} ${
                      nonCompletedUsersCount > 3
                        ? ` ,${nonCompletedUsersCount - 3} More`
                        : ''
                    }`}
                    onClick={() =>
                      goToManagerInsightsContentDetail({
                        insightId,
                        managerId,
                        cid: content.id,
                        contentType: content.contentType,
                      })
                    }
                  />
                );
              }}
            />
          ),
        },
        {
          id: '2',
          title: 'Users',
          count: userCount,
          content: (
            <SearchContainer
              type='user'
              keyword={keyword}
              data={users}
              onCountChange={setUserCount}
              searchField='name'
              rowRender={(user) => (
                <TeamPerformanceCard
                  key={user.id}
                  fullName={user.name}
                  completionPercent={user.percent}
                  completionInformation={`${user.completionCount} of ${contents.length}`}
                  isActive={user.activated}
                  joinDate={
                    user.activated
                      ? formatedDateString(user.activationDate)
                      : formatedDateString(user.createdAt)
                  }
                  onClick={() =>
                    goToManagerInsightsUserDetail({
                      managerId,
                      insightId,
                      uid: user.id,
                    })
                  }
                />
              )}
            />
          ),
        },
      ]}
    />
  );
}

GlobalSearch.propTypes = {
  users: PropTypes.array.isRequired,
  contents: PropTypes.array.isRequired,
  keyword: PropTypes.string.isRequired,
  insightId: PropTypes.string.isRequired,
  managerId: PropTypes.string.isRequired,
  totalUserCount: PropTypes.number.isRequired,
  goToManagerInsightsUserDetail: PropTypes.func.isRequired,
  goToManagerInsightsContentDetail: PropTypes.func.isRequired,
};

export default CSSModules(GlobalSearch, styles, {allowMultiple: true});
